import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {DashboardComponent} from "./index/dashboard.component";
import {AuthGuard} from "../../guards/auth.guard";
import {ManagerComponent} from "./manager/manager.component";
import {ManagerEditComponent} from "./manager-edit/manager-edit.component";
import {ManagerRoleEditComponent} from "./manager-role-edit/manager-role-edit.component";
import {ManagerRoleComponent} from "./manager-role/manager-role.component";
import {ClientComponent} from "./client/client.component";
import {ClientEditComponent} from "./client-edit/client-edit.component";
import {ResetTokenComponent} from "./reset-token/reset-token.component";
import {ResetTokenEditComponent} from "./reset-token-edit/reset-token-edit.component";
import {SettingComponent} from "./setting/setting.component";
import {SettingEditComponent} from "./setting-edit/setting-edit.component";
import {ClientLogComponent} from "./client-log/client-log.component";
import {ClientLogEditComponent} from "./client-log-edit/client-log-edit.component";
import {ManagerLogComponent} from "./manager-log/manager-log.component";
import {ManagerLogEditComponent} from "./manager-log-edit/manager-log-edit.component";
import {CouponComponent} from "./coupon/coupon.component";
import {CouponEditComponent} from "./coupon-edit/coupon-edit.component";
import {TransactionComponent} from "./transcation/transaction.component";
import {TransactionEditComponent} from "./transaction-edit/transaction-edit.component";
import {TranslateComponent} from "./translate/translate.component";
import {FormComponent} from "./form/form.component";
import {TranslateEditComponent} from "./translate-edit/translate-edit.component";
import {FormEditComponent} from "./form-edit/form-edit.component";
import {DocComponent} from "./doc/doc.component";
import {DocEditComponent} from "./doc-edit/doc-edit.component";
import {SocialComponent} from "./social/social.component";
import {SocialEditComponent} from "./social-edit/social-edit.component";
import {LinkComponent} from "./link/link.component";
import {LinkEditComponent} from "./link-edit/link-edit.component";
import {GalleryComponent} from "./gallery/gallery.component";
import {GalleryEditComponent} from "./gallery-edit/gallery-edit.component";

export const dashboardRoutes: Routes = [

  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [{
      path: "index",
      component: DashboardComponent,
    }, {
      path: "manager",
      component: ManagerComponent,
    },{
      path: "manager-edit/:id",
      component: ManagerEditComponent,
    },{
      path: "manager-create",
      component: ManagerEditComponent,
    },{
      path: "manager-role",
      component: ManagerRoleComponent,
    },{
      path: "manager-role-edit/:id",
      component: ManagerRoleEditComponent,
    },{
      path: "manager-role-create",
      component: ManagerRoleEditComponent,
    },{
      path: "client",
      component: ClientComponent,
    },{
      path: "client-edit/:id",
      component: ClientEditComponent,
    },{
      path: "client-create",
      component: ClientEditComponent,
    },{
      path: "reset-token",
      component: ResetTokenComponent,
    },{
      path: "reset-token-edit/:id",
      component: ResetTokenEditComponent,
    },{
      path: "reset-token-create",
      component: ResetTokenEditComponent,
    },{
      path: "setting",
      component: SettingComponent,
    },{
      path: "setting-edit/:id",
      component: SettingEditComponent,
    },{
      path: "setting-create",
      component: SettingEditComponent,
    },{
      path: "client-log",
      component: ClientLogComponent,
    },{
      path: "client-log-edit/:id",
      component: ClientLogEditComponent,
    },{
      path: "client-log-create",
      component: ClientLogEditComponent,
    },{
      path: "manager-log",
      component: ManagerLogComponent,
    },{
      path: "manager-log-edit/:id",
      component: ManagerLogEditComponent,
    },{
      path: "manager-log-create",
      component: ManagerLogEditComponent,
    },{
      path: "coupon",
      component: CouponComponent,
    },{
      path: "coupon-edit/:id",
      component: CouponEditComponent,
    },{
      path: "coupon-create",
      component: CouponEditComponent,
    },{
      path: "transaction",
      component: TransactionComponent,
    },{
      path: "transaction-edit/:id",
      component: TransactionEditComponent,
    },{
      path: "transaction-create",
      component: TransactionEditComponent,
    },{
      path: "form",
      component: FormComponent,
    },{
      path: "form-edit/:id",
      component: FormEditComponent,
    },{
      path: "form-create",
      component: FormEditComponent,
    },{
      path: "doc",
      component: DocComponent,
    },{
      path: "doc-edit/:id",
      component: DocEditComponent,
    },{
      path: "doc-create",
      component: DocEditComponent,
    },{
      path: "social",
      component: SocialComponent,
    },{
      path: "social-edit/:id",
      component: SocialEditComponent,
    },{
      path: "social-create",
      component: SocialEditComponent,
    },{
      path: "translate",
      component: TranslateComponent,
    },{
      path: "translate-edit/:id",
      component: TranslateEditComponent,
    },{
      path: "translate-create",
      component: TranslateEditComponent,
    },{
      path: "link",
      component: LinkComponent,
    },{
      path: "link-edit/:id",
      component: LinkEditComponent,
    },{
      path: "link-create",
      component: LinkEditComponent,
    },{
      path: "gallery",
      component: GalleryComponent,
    },{
      path: "gallery-edit/:id",
      component: GalleryEditComponent,
    },{
      path: "gallery-create",
      component: GalleryEditComponent,
    },
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(dashboardRoutes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
